import { ReactNode } from 'react';

import { TruncatedText } from '@/components/atoms/TruncatedText/TruncatedText';
import { renderDialogIcon } from '@/components/organisms/SubNav/TreeView/Item';

type NodeOptionLabelProps = {
  label: string;
  nodeType?: string;
  /** Replaces the node type's icon. */
  icon?: ReactNode;
  /** Where the full name shows when it is cut off. */
  side: 'top' | 'right';
};

export const NodeOptionLabel = ({ label, nodeType, icon, side }: NodeOptionLabelProps) => (
  <span className="flex min-w-0 items-center gap-2 [&>svg]:shrink-0">
    {icon ?? (nodeType && renderDialogIcon(nodeType))}
    <TruncatedText text={label} side={side} size="large" />
  </span>
);
